import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Popover, Divider, Avatar } from 'antd';

export const ProfilePhoto = props => {
  const content = (
    <React.Fragment>
      {props.activeProfile.profileId && (
        <React.Fragment>
          <Link
            to="/system_settings/profile"
            className="photo__link"
            style={{
              color: '#323232',
            }}
          >
            Мой профиль
          </Link>
          <Button
            style={{
              // padding: '8px 12px 0',
              color: '#323232',
            }}
            onClick={() => {
              localStorage.removeItem('activeProfile');
              props.unsetActiveProfile(null);
            }}
            type="link"
          >
            Сменить профиль
          </Button>
        </React.Fragment>
      )}
      {props.activeProfile.profileId && <Divider style={{ margin: 0 }} />}
      <Button
        style={{
          // padding: '8px 12px',
          color: '#323232',
        }}
        onClick={() => {
          props.resetLogin();
          props.unsetActiveProfile(null);
          props.disableCaption();
        }}
        type="link"
      >
        Выйти
      </Button>
    </React.Fragment>
  );
  return (
    <Popover
      className="profilePhoto"
      content={content}
      title={null}
      trigger="click"
    >
      {props.url ? (
        <img src={props.url} alt="avatar" />
      ) : (
        <Avatar size={40} icon="user" />
      )}
    </Popover>
  );
};
